export default __webpack_public_path__ + "static/media/recurve_bow.bafcde86.png";